import { NgModule } from '@angular/core';
import { NbDialogModule, NbSpinnerModule } from '@nebular/theme';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from '../../../shared/shared.module';
import { UploadTreatmentRoutingModule } from './upload-treatment-routing.module';
import { UploadTreatmentComponent } from './upload-treatment.component';
import { UploadTreatmentFilesComponent } from './upload-treatment-files/upload-treatment-files.component';
import { UploadTreatmentTableComponent } from './upload-treatment-table/upload-treatment-table.component';
import { UploadTreatmentAddWellComponent } from './upload-treatment-add-well.component';
import { UploadTreatmentDetailComponent } from './upload-treatment-detail/upload-treatment-detail.component';

import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { UploadTreatmentSelectFilesComponent } from './upload-treatment-select-files/upload-treatment-select-files.component';


@NgModule({
  declarations: [
    UploadTreatmentComponent,
    UploadTreatmentFilesComponent,
    UploadTreatmentTableComponent,
    UploadTreatmentAddWellComponent,
    UploadTreatmentDetailComponent,
    UploadTreatmentSelectFilesComponent
  ],
  imports: [
    SharedModule,
    NgbProgressbarModule,
    NbDialogModule.forRoot(),
    NbSpinnerModule,
    FileUploadModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,

    UploadTreatmentRoutingModule
  ],
  exports: [
    UploadTreatmentComponent
  ],
  entryComponents: [UploadTreatmentAddWellComponent],
  providers: [
  ]
})
export class UploadTreatmentModule { }
